import { HeaderSelectionCell } from "@progress/kendo-react-data-tools";
import React from "react";
import Common_Title from "../../common-components/common_title/Common_Title";
import "./Vision_Mission.css";
import parse from "html-react-parser";

function Vision_Mission({ content }) {
  return (
    <section className="vision_mission">
      <div className="container">
        <div className="card_wrapper ">
          <div className="mission_card ">
            <div className="title">
              <Common_Title titleStart="Our Mission" />
              <div className="img_wrapper">
                <img src="/assets/images/about_us/vision-mission/mission-logo1.png" />
              </div>
            </div>
            <div className="mission_text">
              <p className="description">{parse(content?.our_mission || "")}</p>
            </div>
          </div>

          <div className="vission_card ">
            <div className="title">
              <Common_Title titleStart="Our Vision" />
              <div className="img_wrapper">
                <img src="/assets/images/about_us/vision-mission/vision-logo1.png" />
              </div>
            </div>
            <div className="mission_text">
              <p className="description">{parse(content?.our_vision || "")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Vision_Mission;
